export default __webpack_public_path__ + "static/media/empty-box.156b637a.svg";